import {TileCacheLayer} from '../TileCacheLayer.js';
import Library from '../Library.js';

export class SatelliteLayer extends TileCacheLayer {

    constructor( map, settings = {} ){
        if( settings.name == undefined ) settings['name'] = "satellite";
        if( settings.type == undefined ) settings['type'] = "sat_ir";
        if( settings.opacity == undefined ) settings['opacity'] = 0.5;
        settings["dynamic_time"] = true;
        super( map, settings );
        this.setLabel();
    }

    refresh(){
        this.setLabel();
        super.refresh();
    }

    async setLabel(){
        let elem = document.getElementById('label_satellite');
        if( elem == null ) return;
        let url = new URL( this.map.server + "/cgi-bin/image/satellite.php" );
        url.searchParams.set( "type", this.settings['type']);
        url.searchParams.set( "output", "label" );
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        let response = await fetch( url.toString());
        let label = await response.text();
        elem.innerText = label;
        console.info( 'satellite label', label );
    }
   
    setType(val){
        this.settings['type'] = val;
        this.refresh();
    }

    updateTime(){
        this.refresh();
    }
}
